query PendingBatchSuggestionCount {
  batchSuggestions(filter: { scheduledToSend: true }) {
    totalCount
  }
}
